import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const CreateUserForm = ({ form, setForm, onSubmit, onCancel, loading }) => {
  return (
    <Card className="bg-card border-border rounded-2xl p-8 mb-8 animate-scale-in">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-foreground">Creare Utilizator Nou</h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={onCancel}
          className="rounded-xl"
        >
          Anulează
        </Button>
      </div>

      <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="new-full-name">Nume complet</Label>
          <Input
            id="new-full-name"
            type="text"
            placeholder="Ion Popescu"
            value={form.full_name}
            onChange={(e) => setForm({ ...form, full_name: e.target.value })}
            required
            className="rounded-xl"
            data-testid="create-user-fullname"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="new-username">Nume utilizator</Label>
          <Input
            id="new-username"
            type="text"
            placeholder="ionpopescu"
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            required
            className="rounded-xl"
            data-testid="create-user-username"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="new-email">Email</Label>
          <Input
            id="new-email"
            type="email"
            placeholder="ion.popescu@example.com"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
            className="rounded-xl"
            data-testid="create-user-email"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="new-password">Parolă</Label>
          <Input
            id="new-password"
            type="password"
            placeholder="••••••••"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
            className="rounded-xl"
            data-testid="create-user-password"
          />
        </div>

        <div className="md:col-span-2">
          <Button
            type="submit"
            className="w-full rounded-xl"
            variant="premium"
            disabled={loading}
            data-testid="create-user-submit"
          >
            {loading ? 'Se creează...' : 'Creează Utilizator'}
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default CreateUserForm;
